import { EventEmitterUtil } from '@chesscom/web-ui';
import { Logger } from 'api/logger/config/types';

const { createEventEmitter } = EventEmitterUtil;

/**
 * Create the logger.
 */
export function createLoggerAPI(maxEntries = 100): Logger.API {
  const emitter = createEventEmitter();
  const logs: Logger.Entry[] = [];
  let currentLevel = Logger.Levels.Debug;
  const levelOrder = {
    [Logger.Levels.None]: 0,
    [Logger.Levels.Error]: 1,
    [Logger.Levels.Debug]: 2,
  };

  return {
    ...emitter,
    clear,
    get,
    log,
    setLogLevel,
  };

  /**
   * Clear the logs.
   */
  function clear() {
    logs.length = 0;
  }

  /**
   * Get all logs.
   */
  function get(filterByProps?: Partial<Logger.Entry>): Logger.Entry[] {
    return filterByProps
      ? logs.filter((entry) =>
          Object.entries(filterByProps).every(([key, value]) => entry[key] === value),
        )
      : logs;
  }

  /**
   * Create a log entry.
   */
  function log({
    code,
    data,
    level = Logger.Levels.Debug,
    message,
  }: {
    code: string;
    data: any;
    level: Logger.Levels;
    message?: string;
  }): void {
    if (levelOrder[level] > levelOrder[currentLevel]) {
      return;
    }

    // If the log array is already full, remove the first entry before proceeding
    if (logs.length === maxEntries) {
      logs.shift();
    }

    const entry = {
      code,
      data,
      level,
      message,
      timestamp: Date.now(),
    };

    logs.push(entry);

    emitter.emit(Logger.Events.EntryAdded, entry);
  }

  /**
   * Set the current log level.
   */
  function setLogLevel(newLevel: Logger.Levels): void {
    currentLevel = newLevel;
  }
}
